import React from 'react';
import { motion } from 'framer-motion';

const CognitiveCorporate = () => {
	return (
		<section className="relative min-h-screen sm:h-screen flex items-center overflow-hidden py-8 sm:py-12 md:py-16 lg:py-0" style={{ background: 'linear-gradient(180deg, #FFFFFF 23.08%, #D9D9D9 100%)' }}>
			{/* Top-Left Accent Arrow */}
			

			<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-12 md:py-16 lg:py-20 w-full">
            <motion.div 
							className="space-y-2 text-center lg:text-left"
							initial={{ y: 30, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, ease: "easeOut" }}
						>
							<h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-source font-semibold text-[#113861] leading-tight">
								Sports Psychology & Performance
							</h2>
							<h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-source italic text-[#113861] leading-tight">
								Solutions
							</h3>
						</motion.div>

				<div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-start">
					{/* Left Side - Main Content */}
					<div className="lg:col-span-7 space-y-4 sm:space-y-6 md:space-y-8">
						{/* Main Title */}
						
						{/* Descriptive Paragraph */}
						<motion.p 
							className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0 mt-6 sm:mt-8 md:mt-12 lg:mt-16"
							initial={{ y: 30, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						>
							Talent alone doesn't guarantee success, and athletes face pressure, inconsistency, and mental blocks that can derail performance. Our clarity-driven approach measures and strengthens the cognitive and emotional skills that fuel success in sports, from focus and resilience to decision-making under pressure. By partnering with academies, coaches, and teams, we integrate data-driven insights into training, ensuring athletes unlock their full potential, sustain high performance, and thrive in competitive arenas.
						</motion.p>
					</div>

					{/* Right Side - Heading and Tree Image */}
					<div className="lg:col-span-5 space-y-4 sm:space-y-6 md:space-y-8 text-center lg:text-left">
						{/* Right Heading */}
						<motion.h4 
							className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-sans font-regular text-[#113861] leading-tight mt-6 sm:mt-8 md:mt-12 lg:mt-16"
							initial={{ x: 30, opacity: 0 }}
							whileInView={{ x: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
						>
							Building mental resilience for consistent, peak performance
						</motion.h4>

						{/* Tree Image Container - Mobile/Tablet Layout */}
						<motion.div 
							className="lg:hidden flex justify-center mt-6 sm:mt-8 md:mt-12"
							initial={{ scale: 0.8, opacity: 0 }}
							whileInView={{ scale: 1, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 1, ease: "easeOut" }}
						>
							<img
								src="/images/glass-sphere.png"
								alt="Vibrant stylized tree with colorful translucent leaves"
								className="w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 object-contain"
								style={{ 
									filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
									width: '100%',
									height: '100%',
									objectFit: 'contain'
								}}
							/>
						</motion.div>
					</div>
				</div>
			</div>

			{/* Desktop Image - Absolute Positioning (Original Layout) */}
			<motion.div 
				className="hidden lg:block absolute top-0 right-0 z-0 w-full h-full flex items-start justify-end"
				initial={{ scale: 0.8, opacity: 0 }}
				whileInView={{ scale: 1, opacity: 1 }}
				viewport={{ once: true, amount: 0.3 }}
				transition={{ duration: 1, ease: "easeOut" }}
			>
				<img
					src="/images/glass-sphere.png"
					alt="Vibrant stylized tree with colorful translucent leaves"
					className="w-[40%] h-full object-contain"
					style={{ 
						filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
						width: '40%',
						height: '100%',
						position: 'absolute',
						objectFit: 'contain',
						right: '-12%',
						top: '42%'
					}}
				/>
			</motion.div>
		</section>
	);
};

export default CognitiveCorporate;